import React from "react";
import { Button, Typography } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

const FlexiAiButton = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      disableElevation
      variant="outlined"
      startIcon={<AutoFixHighIcon sx={{ fontSize: 18 }} />}
      sx={{
        textTransform: "none",
        fontSize: 16,
        fontWeight: 500,
        color: "#111",
        borderColor: "#111",
        borderWidth: 2,
        borderRadius: "999px",
        px: 3,
        py: 1,
        mr: 2,
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#111",
          color: "#fff",
          borderColor: "#111",
        },
      }}
    >
      <Typography component="span" sx={{ fontSize: 16, fontWeight: 500 }}>
        flexi{" "}
        <Typography
          component="span"
          sx={{
            fontSize: 16,
            fontWeight: 700,
            display: "inline",
            color: "inherit",
          }}
        >
          AI
        </Typography>
      </Typography>
    </Button>
  );
};

export default FlexiAiButton;
